/**
 * Captura e guarda do token da campanha de SMS (?c= na URL do cardapio).
 *
 * O redirect do link curto cruza do apex pro subdominio da loja, e cookie do
 * apex nao e' lido aqui — por isso o token viaja na query e mora no
 * localStorage COM PRAZO. E' o que faz o rastreio sobreviver ao cliente fechar
 * o navegador e voltar horas depois pelo historico.
 *
 * Esta era a metade do funil que faltou na v1 (bug real: pedido #83804 veio do
 * link e nao atribuiu): o backend sempre soube receber sms_ref, mas ninguem
 * capturava nem enviava.
 */
const CHAVE = "nucleo_sms_ref";
const PRAZO_MS = 7 * 24 * 60 * 60 * 1000; // mesma janela de atribuicao padrao

export function capturarSmsRef() {
  try {
    const c = new URLSearchParams(window.location.search).get("c");
    if (c && /^[2-9a-zA-Z]{3,8}$/.test(c)) {
      localStorage.setItem(CHAVE, JSON.stringify({ token: c, expira: Date.now() + PRAZO_MS }));
    }
  } catch { /* storage bloqueado: rastreio vira melhor esforco */ }
}

export function obterSmsRef() {
  try {
    const bruto = localStorage.getItem(CHAVE);
    if (!bruto) return undefined;
    const { token, expira } = JSON.parse(bruto);
    if (!token || Date.now() > expira) {
      localStorage.removeItem(CHAVE);
      return undefined;
    }
    return token;
  } catch {
    return undefined;
  }
}
